var map = {
	"./DrLubhani/ChangeColor": [
		738,
		171
	],
	"./Ganga/ChangeColor": [
		740,
		177
	],
	"./Indus/ChangeColor": [
		742,
		190
	],
	"./Kabini/ChangeColor": [
		744,
		197
	],
	"./Kaveri/ChangeColor": [
		655,
		20
	],
	"./Luni/ChangeColor": [
		746,
		203
	],
	"./Narmada/ChangeColor": [
		748,
		206
	],
	"./Neyyar/ChangeColor": [
		750,
		213
	],
	"./Periyar/ChangeColor": [
		752,
		216
	],
	"./SAANVI/ChangeColor": [
		754,
		226
	],
	"./Sabarmathi/ChangeColor": [
		756,
		233
	],
	"./Sutlej/ChangeColor": [
		758,
		239
	],
	"./Yamuna/ChangeColor": [
		760,
		245
	],
	"./pamba/ChangeColor": [
		762,
		254
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1979;
module.exports = webpackAsyncContext;